<template>
  <div>
    <h1>User groups</h1>

    <tabs>
      <tabs-item :key="tabs.indexOf(tab)" v-for="tab in tabs" :link="tab.to">{{
        tab.title
      }}</tabs-item>
    </tabs>

    <section-block>
      <template slot="header">
        <filter-bar :showSearch="false" resource="UserGroups" />
      </template>
      <template slot="actions">
        <base-button
          @click="$router.push({ name: 'UserGroupsCreate' })"
          iconBefore="addUser"
          :primary="true"
          >Create a group</base-button
        >
      </template>

      <loading v-if="loading"></loading>

      <div v-else-if="groups.length > 0">
        <vuetable
          ref="groupTable"
          :fields="fields"
          :api-mode="false"
          :data="groups"
          class="c-data-table"
        >
          <template slot="members" slot-scope="props">
            {{ props.rowData.user_ids ? props.rowData.user_ids.length : 0 }}
          </template>
          <div slot="action-slot" slot-scope="props">
            <div
              class="action-cell"
              v-if="
                $store.state.auth.currentUser.id === props.rowData.created_user
              "
            >
              <base-tooltip text="Edit Group">
                <router-link
                  :to="{
                    name: 'UserGroupsEdit',
                    params: { groupId: props.rowData.id },
                  }"
                >
                  <icon name="pencil" />
                </router-link>
              </base-tooltip>
              <base-tooltip text="Delete group">
                <a href="#" @click.prevent="onDeleteClick(props.rowData.id)">
                  <icon name="cross" />
                </a>
              </base-tooltip>
            </div>
          </div>
        </vuetable>
      </div>

      <base-empty v-else
        >There are currently no user groups. <br />Why not
        <router-link :to="{ name: 'UserGroupsCreate' }"
          >create one now</router-link
        >?
      </base-empty>
    </section-block>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseEmpty } from "@/components/elements";
import UserGroupActions from "@/components/UserGroupActions";
export default {
  name: "UserGroupsIndex",
  components: { BaseEmpty },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Groups I own",
          to: "/usergroups",
        },
        {
          title: "Groups I'm a member of",
          to: "/usergroups/member",
        },
      ],
      fields: [
        {
          name: "name",
          title: "Group Name",
          sortField: "name",
        },
        {
          name: "members",
          title: "Number of Members",
        },
        {
          name: UserGroupActions,
          title: "Actions",
          titleClass: "u-ta-center u-hide-mobile",
          dataClass: "u-ta-center u-hide-mobile",
          width: "10%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("UserGroups", ["ownerGroups", "memberGroups"]),
    groups() {
      return this.$route.meta.memberFilter
        ? this.memberGroups
        : this.ownerGroups
    },
  },
  created() {
    this.$store.dispatch("UserGroups/list").then((resp) => {
      console.log(
        "🚀 ~ file: Index.vue ~ line 112 ~ this.$store.dispatch ~ resp",
        resp
      );
      this.loading = false;
    });
  },
  methods: {
    onDeleteClick(id) {
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store
            .dispatch("UserGroups/delete", id)
            .then(() => {
              this.$store.dispatch(
                "notifications/create",
                {
                  body: `The group has been deleted`,
                  type: "success",
                },
                { root: true }
              );
            })
            .catch((err) => {
              dispatch(
                "notifications/create",
                {
                  body: `There was a problem - ${err}`,
                  type: "danger",
                },
                { root: true }
              );
            });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
th,
td {
  text-align: center;
}
.action-cell {
  display: flex;
  justify-content: space-around;
}
</style>
